import React from 'react';
import { Button } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { gtmOfferClick } from '../../utils/gtm';

const REFERRALS = {
  wealthsimple: {
    href: 'https://www.wealthsimple.com/invite/Q7KSJA?utm_source=finmaple&utm_medium=referral',
    bank: 'wealthsimple',
  },
  tangerine: {
    href: 'https://www.tangerine.ca/en/landing-page/switch-to-tangerine?orangeKey=60870716S1&utm_source=finmaple&utm_medium=referral',
    bank: 'tangerine',
  },
  borrowell: {
    href: 'https://borrowell.com/refer-a-friend/free-credit-score?utm_campaign=Refer5&utm_medium=web&utm_source=refer2022-3818681',
    bank: 'borrowell',
  },
};

const ReferralCTA = ({ bank, children, variant = 'contained', sx: sxOverride }) => {
  const ref = REFERRALS[bank];
  if (!ref) return null;

  const handleClick = () => {
    if (window.plausible) {
      window.plausible('Referral Click', { props: { bank: ref.bank } });
    }
    gtmOfferClick({ product: 'referral', provider: ref.bank, vertical: 'referral', url: ref.href });
  };

  return (
    <Button
      href={ref.href}
      target="_blank"
      rel="noopener noreferrer sponsored"
      onClick={handleClick}
      variant={variant}
      endIcon={<ArrowForward sx={{ fontSize: 16 }} />}
      sx={{
        bgcolor: variant === 'contained' ? '#C23A22' : 'transparent',
        color: variant === 'contained' ? '#fff' : '#C23A22',
        borderColor: variant === 'outlined' ? '#C23A22' : undefined,
        borderRadius: '8px',
        px: 3,
        py: 1.5,
        fontSize: 14,
        fontWeight: 700,
        textTransform: 'none',
        '&:hover': {
          bgcolor: variant === 'contained' ? '#A83020' : 'rgba(194,58,34,0.08)',
          borderColor: variant === 'outlined' ? '#A83020' : undefined,
        },
        ...sxOverride,
      }}
    >
      {children}
    </Button>
  );
};

export { REFERRALS };
export default ReferralCTA;
